export default __webpack_public_path__ + "static/media/majles_-_2020-05-03.1c15df17.mp3";